<div class="dialog-container">
  <div class="dialog-header"
       layout="row"
       layout-align="space-between center">
    <h2 mat-dialog-title>{{ 'clientPricingOffers.createOffer' | translate }}</h2>
    <button mat-icon-button
            class="margin-right-16px"
            (click)="onCancel()"
            tabindex="-1">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-dialog-content class="dialog-content">
    <form [formGroup]="offerForm"
          (ngSubmit)="onSubmit()">
      <div class="form-section">
        <div layout="row"
             layout-align="start center">
          <mat-form-field flex="50">
            <mat-label>{{ 'clientPricingOffers.accrualType' | translate }}</mat-label>
            <mat-select requied
                        formControlName="accrualTypeCode">
              @for (accrualType of accrualTypes; track accrualType) {
              <mat-option [value]="accrualType">
                {{ accrualType | accrualTypeToTranslationKey | translate }}
              </mat-option>
              }
            </mat-select>
            @if (offerForm.get('accrualTypeCode')?.hasError('required')) {
            <mat-error>{{ 'forms.required' | translate }}</mat-error>
            }
          </mat-form-field>

          <mat-form-field flex="50">
            <mat-label>{{ 'clientPricingOffers.utilizationsLimit' | translate }}</mat-label>
            <input matInput
                   required
                   type="number"
                   formControlName="utilizationsLimit"
                   min="1"
                   [placeholder]="'clientPricingOffers.utilizationsLimitPlaceholder' | translate">
            @if (offerForm.get('utilizationsLimit')?.hasError('min')) {
            <mat-error>{{ 'forms.minValue' | translate }}</mat-error>
            }
            @if (offerForm.get('utilizationsLimit')?.hasError('required')) {
            <mat-error>{{ 'forms.required' | translate }}</mat-error>
            }
            @if (offerForm.get('utilizationsLimit')?.hasError('min')) {
            <mat-error [translate]="'forms.minValue'"
                       [translateParams]="{ value: 1 }">This field is
              required</mat-error>
            }
          </mat-form-field>
        </div>

        <div layout="row"
             layout-align="start center">
          <mat-form-field flex="33">
            <mat-label>{{ 'clientPricingOffers.valueType' | translate }}</mat-label>
            <mat-select required
                        formControlName="valueType">
              @for (type of valueTypeValues; track type) {
              <mat-option [value]="type">
                {{ type | valueTypeTranslationPipe | translate }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field flex="33">
            <mat-label>{{ 'clientPricingOffers.changeDirection' | translate }}</mat-label>
            <mat-select required
                        formControlName="changeDirection">
              @for (direction of changeDirectionValues; track direction) {
              <mat-option [value]="direction">
                {{ direction | changeDirectionTranslationPipe | translate }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>

          <mat-form-field flex="33">
            <mat-label>{{ 'clientPricingOffers.value' | translate }}</mat-label>
            <input matInput
                   type="number"
                   required
                   formControlName="value"
                   min="0"
                   step="1">
            @if (offerForm.get('valueType')?.value === clientPricingOfferValuesTypes.PERCENT) {
            <span class="value-type"
                  matSuffix>{{ 'global.percentageSign' | translate }}</span>
            } @else if (offerForm.get('valueType')?.value === clientPricingOfferValuesTypes.AMOUNT) {
            <span class="value-type" matSuffix> {{fxService.currencySymbol()}} </span>

            }
            @if (offerForm.get('value')?.hasError('required')) {
            <mat-error>{{ 'forms.required' | translate }}</mat-error>
            }
            @if (offerForm.get('value')?.hasError('min')) {
            <mat-error [translate]="'forms.minValue'"
                       [translateParams]="{ value: 0 }">This field is
              required</mat-error>
            }
          </mat-form-field>
        </div>
      </div>

      <div class="form-section">
        <div layout="row"
             layout-align="start center">
          <mat-form-field flex="50">
            <mat-label>{{ 'clientPricingOffers.validFrom' | translate }}</mat-label>
            <input matInput
                   required
                   [min]="currentDate"
                   [matDatepicker]="fromPicker"
                   formControlName="validFrom">
            <mat-datepicker-toggle matSuffix
                                   [for]="fromPicker"></mat-datepicker-toggle>
            <mat-datepicker [touchUi]="false"
                            #fromPicker></mat-datepicker>
            @if (offerForm.get('validFrom')?.hasError('required')) {
            <mat-error>{{ 'forms.required' | translate }}</mat-error>
            }
            <mat-hint>дд/мм/ГГГГ</mat-hint>
          </mat-form-field>

          <mat-form-field flex="50">
            <mat-label>{{ 'clientPricingOffers.validTo' | translate }}</mat-label>
            <input matInput
                   required
                   [min]="tomorrowDate"
                   [matDatepicker]="toPicker"
                   formControlName="validTo">
            <mat-datepicker-toggle matSuffix
                                   [for]="toPicker"></mat-datepicker-toggle>
            <mat-datepicker [touchUi]="false"
                            #toPicker></mat-datepicker>
            @if (offerForm.get('validTo')?.hasError('required')) {
            <mat-error>{{ 'forms.required' | translate }}</mat-error>
            }
            <mat-hint>дд/мм/ГГГГ</mat-hint>
          </mat-form-field>
        </div>
      </div>
    </form>
  </mat-dialog-content>

  <mat-dialog-actions align="end"
                      class="dialog-actions">
    <button mat-raised-button
            class="margin-right-24px"
            color="primary"
            (click)="onSubmit()"
            [disabled]="isLoading">
      <div layout="row"
           layout-align="center center">
        @if (isLoading) {
        <mat-spinner diameter="20"></mat-spinner>
        } @else {
        <span>{{ 'global.create' | translate }}</span>
        }
      </div>
    </button>
  </mat-dialog-actions>
</div>
